(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["complete-the-look"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__completeTheLookInit) return;
    window.__completeTheLookInit = true;

    function initCarousel(section) {
      if (section.dataset.carouselReady) return;
      var track = section.querySelector('[data-carousel-track]');
      var prev = section.querySelector('[data-carousel-prev]');
      var next = section.querySelector('[data-carousel-next]');
      if (!track || !prev || !next) return;
      section.dataset.carouselReady = 'true';

      function step() {
        var card = track.querySelector('.complete-the-look-card');
        if (!card) return track.clientWidth;
        var style = window.getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
        return card.offsetWidth + gap;
      }

      function update() {
        var atStart = track.scrollLeft <= 1;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
        prev.disabled = atStart;
        next.disabled = atEnd;
      }

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    function initAll() {
      document.querySelectorAll('[data-complete-the-look]').forEach(initCarousel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('[data-complete-the-look]');
      if (section) initCarousel(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__pageGalleryInit) return;
    window.__pageGalleryInit = true;

    // Shopify CDN URL upgrader: image_480x480.jpg -> image_1600x.jpg
    function upgradeImg(src) {
      if (!src) return src;
      return src.replace(/_(\d+)x(\d*)(\.[a-z]+)/i, function (m, w, h, ext) {
        if (parseInt(w, 10) >= 1600) return m;
        return '_1600x' + ext;
      });
    }

    function buildLightbox() {
      var lb = document.createElement('div');
      lb.className = 'page-gallery-lightbox';
      lb.hidden = true;
      lb.innerHTML =
        '<button type="button" class="page-gallery-lightbox-close" aria-label="Close">' +
          '<svg viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none"/></svg>' +
        '</button>' +
        '<button type="button" class="page-gallery-lightbox-nav prev" aria-label="Previous">' +
          '<svg viewBox="0 0 24 24"><path d="M15 6l-6 6 6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>' +
        '</button>' +
        '<button type="button" class="page-gallery-lightbox-nav next" aria-label="Next">' +
          '<svg viewBox="0 0 24 24"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>' +
        '</button>' +
        '<img alt="">';
      document.body.appendChild(lb);

      var imgEl = lb.querySelector('img');
      var sources = [];
      var index = 0;

      function show(i) {
        if (!sources.length) return;
        index = (i + sources.length) % sources.length;
        imgEl.src = sources[index];
      }
      function open(list, i) {
        sources = list;
        show(i);
        lb.hidden = false;
        document.body.style.overflow = 'hidden';
      }
      function close() {
        lb.hidden = true;
        imgEl.src = '';
        document.body.style.overflow = '';
      }

      lb.querySelector('.page-gallery-lightbox-close').addEventListener('click', close);
      lb.querySelector('.prev').addEventListener('click', function () { show(index - 1); });
      lb.querySelector('.next').addEventListener('click', function () { show(index + 1); });
      lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
      document.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowLeft') show(index - 1);
        if (e.key === 'ArrowRight') show(index + 1);
      });

      return { open: open };
    }

    var lightbox;
    function getLightbox() {
      if (!lightbox) lightbox = buildLightbox();
      return lightbox;
    }

    function init(section) {
      if (section.dataset.galleryReady) return;
      section.dataset.galleryReady = 'true';

      var layout = section.querySelector('[data-page-gallery-layout]');
      var source = section.querySelector('[data-page-gallery-source]');

      // 1. If page.content is the source, extract iframe + images and append
      if (source && layout) {
        var iframe = source.querySelector('iframe');
        if (iframe) {
          var wrap = document.createElement('div');
          wrap.className = 'page-gallery-video';
          var newIframe = document.createElement('iframe');
          newIframe.src = iframe.src;
          newIframe.title = iframe.title || 'Video';
          newIframe.allow = iframe.getAttribute('allow') || 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
          newIframe.setAttribute('allowfullscreen', '');
          newIframe.setAttribute('frameborder', '0');
          wrap.appendChild(newIframe);
          // Insert videos before any existing image grid
          var existingGrid = layout.querySelector('[data-page-gallery-grid]');
          if (existingGrid) {
            layout.insertBefore(wrap, existingGrid);
          } else {
            layout.appendChild(wrap);
          }
        }

        var imgs = source.querySelectorAll('img');
        if (imgs.length) {
          var grid = layout.querySelector('[data-page-gallery-grid]');
          if (!grid) {
            grid = document.createElement('div');
            grid.className = 'page-gallery-images';
            grid.setAttribute('data-page-gallery-grid', '');
            layout.appendChild(grid);
          }
          imgs.forEach(function (img) {
            var tile = document.createElement('div');
            tile.className = 'page-gallery-img';
            var newImg = document.createElement('img');
            newImg.src = img.src; // keep thumbnail for grid
            newImg.alt = img.alt || '';
            newImg.loading = 'lazy';
            newImg.setAttribute('data-full', upgradeImg(img.src));
            tile.appendChild(newImg);
            grid.appendChild(tile);
          });
        }

        source.remove();
      }

      // 2. Wire up lightbox for all image tiles in the layout
      var grid = layout && layout.querySelector('[data-page-gallery-grid]');
      if (grid) {
        grid.addEventListener('click', function (e) {
          var tile = e.target.closest('.page-gallery-img');
          if (!tile) return;
          var tiles = Array.prototype.slice.call(grid.querySelectorAll('.page-gallery-img'));
          var sources = tiles.map(function (t) {
            var img = t.querySelector('img');
            return img ? (img.getAttribute('data-full') || img.src) : '';
          }).filter(Boolean);
          getLightbox().open(sources, tiles.indexOf(tile));
        });
      }
    }

    function initAll() {
      document.querySelectorAll('.page-gallery').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('.page-gallery');
      if (section) init(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-archive"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__videoArchiveInit) return;
    window.__videoArchiveInit = true;

    function closeLightbox(lightbox) {
      if (!lightbox) return;
      var frame = lightbox.querySelector('.video-lightbox-frame');
      if (frame) frame.innerHTML = '';
      lightbox.hidden = true;
      document.body.style.overflow = '';
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.video-archive .video-trigger');
      if (trigger) {
        var videoId = trigger.dataset.videoId;
        var section = trigger.closest('.video-archive');
        var lightbox = section && section.querySelector('.video-lightbox');
        var frame = lightbox && lightbox.querySelector('.video-lightbox-frame');
        if (!videoId || !lightbox || !frame) return;

        var iframe = document.createElement('iframe');
        iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(videoId) + '?autoplay=1&rel=0';
        iframe.title = 'YouTube video player';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen = true;

        frame.innerHTML = '';
        frame.appendChild(iframe);
        lightbox.hidden = false;
        document.body.style.overflow = 'hidden';
        return;
      }

      var lb = e.target.closest('.video-archive .video-lightbox');
      if (lb && (e.target === lb || e.target.closest('.video-lightbox-close'))) {
        closeLightbox(lb);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = document.querySelector('.video-archive .video-lightbox:not([hidden])');
      if (open) closeLightbox(open);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
